import React from 'react';
import { fmtN } from './JoBits';

const day = (iso) => new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

const dates = (s) => {
  if (!s.first_at) return s.waiting_pcs ? 'none passed yet' : 'not reached yet';
  const a = day(s.first_at);
  const b = day(s.last_at);
  return a === b ? `passed on ${a}` : `passed ${a} → ${b}`;
};

const dot = (s) => {
  if (s.lost_pcs > 0) return 'bg-rose-500';
  if (s.stuck) return 'bg-amber-500';
  if (s.waiting_pcs > 0) return 'bg-sky-500';
  return s.done_pcs > 0 ? 'bg-emerald-500' : 'bg-gray-300';
};

/** Stage by stage, top to bottom: when pieces passed it (first → latest), how many, and what is still waiting there. */
export const JoTimeline = ({ stages }) => (
  <ol className="ml-2 border-l-2 border-[#E5DFD0] space-y-4" data-testid="jo-timeline">
    {stages.map((s) => (
      <li key={s.key} className="relative pl-5" data-testid={`jo-tl-${s.key}`}>
        <span className={`absolute -left-[9px] top-1 h-4 w-4 rounded-full border-2 border-white ${dot(s)}`} />
        <div className="flex flex-wrap items-baseline gap-x-2">
          <span className={`text-sm font-semibold ${s.done_pcs || s.waiting_pcs ? 'text-gray-900' : 'text-gray-400'}`}>{s.label}</span>
          <span className="text-xs text-gray-500" data-testid={`jo-tl-dates-${s.key}`}>{dates(s)}</span>
        </div>
        <div className="text-xs text-gray-700" data-testid={`jo-tl-pcs-${s.key}`}>
          {fmtN(s.done_pcs)} pcs {s.key === 'damage' ? 'checked' : 'passed'}
          {s.waiting_pcs > 0 && <span className={s.stuck ? 'font-semibold text-amber-800' : ''}> · {fmtN(s.waiting_pcs)} waiting since {day(s.waiting_since)} ({s.oldest_days}d)</span>}
          {s.lost_pcs > 0 && <span className="font-semibold text-rose-700"> · {fmtN(s.lost_pcs)} rejected</span>}
        </div>
      </li>
    ))}
  </ol>
);
